function findSellingPlanById(plans, idNumber) {
    const fullId = `gid://shopify/SellingPlan/${idNumber}`;
    return plans.find(item => item.id === fullId);
}

function determineQty() {
    const quantityInput = document.querySelector('quantity-input')
    const input = quantityInput.querySelector('input');
    return input.value
}

function numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


function addQtySelectorSubPricing(isSubscriptionTemplate = false) {
    const quantityInput = document.querySelector('.pdp-quantity')
    if (quantityInput) {
        quantityInput.addEventListener('change', (e) => {

            const input = quantityInput.querySelector('input');
            const productPrice = Number(RS.Config.product.price);
            const oneTimeQtyPrice = (productPrice / 100 * input.value).toFixed(2)

            const subscriptionPriceContainer = Array.from(document.getElementsByClassName("appstle_price_block"));

            if (subscriptionPriceContainer && subscriptionPriceContainer[0]) {
                subscriptionPriceContainer.forEach(container => {
                    const parentLabel = container.closest('label');
                    if (parentLabel) {
                        // get appstle selling plan info from global RS.Config
                        const sellingPlanID = parentLabel.getAttribute('for')
                        const sellingPlanInfo = findSellingPlanById(RS.Config.sellingPlansJson, sellingPlanID)
                        let qtyPrice

                        // determine discount amount and total qty price from appstle info
                        if (sellingPlanInfo.discountEnabled && sellingPlanInfo.discountOffer) {
                            const discountDollars = (productPrice / 100) * (sellingPlanInfo.discountOffer / 100);
                            const newPrice = (productPrice / 100) - discountDollars;
                            qtyPrice = (newPrice * Number(input.value)).toFixed(2)
                        } else {
                            qtyPrice = ((productPrice / 100) * Number(input.value)).toFixed(2)
                        }

                        // update elements based on product template    
                        if (isSubscriptionTemplate) {
                            const variableSubPrices = Array.from(container.getElementsByClassName("variable_sub_price"));
                            variableSubPrices.forEach(el => el.innerHTML = `${numberWithCommas(qtyPrice)}`)
                        } else {
                            container.childNodes.forEach(node => {
                                if (node.nodeType === Node.TEXT_NODE) {
                                    node.nodeValue = `$${numberWithCommas(qtyPrice)}`;
                                }
                            });
                        }
                    }
                });
            }

            // update one time price include qty based on product template
            if (isSubscriptionTemplate) {
                const variableOnePrices = Array.from(document.getElementsByClassName("variable_one_price"));
                variableOnePrices.forEach(el => el.innerHTML = `$${numberWithCommas(oneTimeQtyPrice)}`)
                return
            }

            const oneTimeContainer = Array.from(document.getElementsByClassName('appstle_onetime_amount'))
            if (oneTimeContainer && oneTimeContainer[0]) {
                const oneTimeText = oneTimeContainer[0].innerHTML.split('/').pop()
                oneTimeContainer[0].innerHTML = `$${numberWithCommas(oneTimeQtyPrice)}/${oneTimeText}`
            }
        })
    }
}

window.onload = () => {
    addQtySelectorSubPricing()
}